import { uuid } from '@/lib'
import * as action from '../store/action-types'
import TemplateDefinitionsService from '../services/template-definitions.service'

class AppService {
  constructor ($store, $keycloak) {
    this.$store = $store
    this.templateDefinitionsService = new TemplateDefinitionsService($keycloak, $store)
  }

  openCreateDataset ({datasetId, name, url, columns}, componentType) {
    datasetId = datasetId || uuid()
    this.$store.dispatch(action.DATASET_DELETE, {datasetId})
    this.$store.dispatch(action.DATASET_CREATE, {
      componentType,
      datasetId,
      name: 'Dataset ' + name,
      dataUrl: url,
      columns
    })
    return datasetId
  }

  openCreateTemplate (options) {
    let template = this.templateDefinitionsService.findTemplateDefinition(options.componentType)
    if (!template) {
      console.error('Could not find template definition with componentType "' + options.componentType + '"')
      return
    }
    template = Object.assign({}, template)
    template.templateId = options.templateId || uuid()
    template.name = options.name
    template.data = Object.assign({}, options.templateData, {columnMap: options.columnMap})
    template.options = Object.assign({}, options.templateOptions)
    template.overlay = {
      data: Object.assign({}, template.overlay && template.overlay.data, {title: options.title}, options.overlayData),
      options: Object.assign({}, template.overlay && template.overlay.options, options.overlayOptions)
    }
    template.overlays = options.overlays || template.overlays
    this.$store.dispatch(action.TEMPLATE_DELETE, {templateId: template.templateId})
    this.$store.dispatch(action.TEMPLATE_CREATE, template)
  }
}

export default AppService



// WEBPACK FOOTER //
// ./src/api/AppService.js